import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnInit,
    ViewChild
} from '@angular/core';
import {TableViewModel, Value} from '@components/models/table';
import {ApiService} from '@services/api.service';
import {AppService} from '@services/app.service';
import {PaginationService} from '@components/pagination/pagination.service';
import {ExcelService} from '@services/excel.service';
import {SwitchService} from '@services/switch.service';
import {Subscription, timer} from 'rxjs';
import jsPDF from 'jspdf';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';
import {OldEnlistment} from '@/models/OldEnlistment';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-manage-old-enlistments',
    templateUrl: './manage-old-enlistments.component.html',
    styleUrls: ['./manage-old-enlistments.component.scss']
})
export class ManageOldEnlistmentsComponent implements OnInit {
    old_currentPage: number = 1;
    old_pageSize: number = 5;
    selected_enlistment: any;
    selected_form: any;
    old_enlistments: any[] = null;
    old_enlistments_count: number = null;
    old_vehicles_count: number = null;
    old_ok_enlistments_count: number = null;
    old_enlistmentModel: TableViewModel = {
        // title: 'Alistamientos V.1',
        description: '',
        filter: {
            page: 1,
            pageSize: 5
        },
        fields: [
            {title: 'Folio', key: 'folio', filter: true, data: []},
            {title: 'Fecha', key: 'fecha', filter: true, data: []},
            {
                title: 'Conductor',
                key: 'conductor',
                filter: true,
                filterDriver: true,
                data: this.getDriverValues()
            },
            {
                title: 'Vehiculo',
                key: 'vehiculo',
                filter: true,
                filterUnit: true,
                data: this.getUnitValues()
            },
            {
                title: 'Formulario Covid',
                key: 'covid',
                filter: false,
                filterCovid: true,
                data: []
            },
            {
                title: 'Estado',
                key: 'state',
                filter: true,
                data: [],
                type: 'ec-status'
            },
            {
                title: 'RC',
                key: 'rc_check',
                filter: false,
                data: [],
                type: 'ec-rc'
            },
            {
                title: 'RG',
                key: 'rg_check',
                filter: false,
                data: [],
                type: 'ec-rg'
            },

        ],
        records: [],
        showFilters: true,
        enableActions: true,
        isModal: false
    };
    old_searchby: string = '';
    show_single_enlistment: boolean = false;
    show_single_covid_form: boolean = false;
    modalCovidRef: any;
    data: OldEnlistment = null;
    loading: boolean = false;
    account: any;
    motion_logo = `data:image/png;base64,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`;

    private suscription: Subscription;

    constructor(
        private apiService: ApiService,
        private appService: AppService,
        private cd: ChangeDetectorRef,
        private pS: PaginationService,
        private excelService: ExcelService,
        private modalService: SwitchService,
        private route: ActivatedRoute,
    ) {
        const timer$ = timer(100, 1000);
        this.suscription = timer$.subscribe(() => this.cd.detectChanges());
    }

    ngOnInit(): void {
        this.getOldEnlistments(this.old_currentPage, this.old_searchby);
        this.modalService.$modal.subscribe((value) => {
            this.show_single_enlistment = value;
        });
        this.modalService.$card_selected.subscribe((value) => {
            this.show_single_covid_form = value;
        });
        this.appService.getAccountInfo().then((account) => {
            account ? (this.account = account) : this.logout();
        });
    }

    logout() {
        this.appService.logout();
    }

    getOldEnlistments(currentPage, searchby) {
        this.apiService
            .getOldEnlistmentsInfo(currentPage, this.old_pageSize, searchby)
            .then((enlistments) => {
                if (enlistments.count > 0) {
                    this.old_ok_enlistments_count = enlistments.ok_count;
                    this.old_enlistments = enlistments.result;
                    this.old_enlistments_count = enlistments.total_count;
                    this.old_enlistmentModel.records = this.old_enlistments;
                    this.old_enlistmentModel.pagination = {
                        currentPage: this.old_currentPage,
                        pageSize: this.old_pageSize,
                        pageCount: enlistments.count,
                        rowCount: this.old_enlistments_count
                    };
                    this.cd.detectChanges();
                }
            });
    }

    getOldEnlistmentSorted(sortby, order) {
        if (order === 'none') {
            this.getOldEnlistments(this.old_currentPage, this.old_searchby);
        } else {
            this.apiService
                .getOldEnlistmentsInfo(
                    this.old_currentPage,
                    this.old_pageSize,
                    '',
                    sortby,
                    order
                )
                .then((enlistments) => {
                    if (enlistments.count > 0) {
                        this.old_enlistments = enlistments.result;
                        this.old_enlistments_count = enlistments.total_count;
                        this.old_enlistmentModel.records = this.old_enlistments;
                        this.old_enlistmentModel.pagination = {
                            currentPage: this.old_currentPage,
                            pageSize: this.old_pageSize,
                            pageCount: enlistments.count,
                            rowCount: this.old_enlistments_count
                        };
                        this.cd.detectChanges();
                    }
                });
        }
    }

    openPDF(data: any): void {
        this.loading = true;
        this.apiService
            .getOldSingleEnlistmentInfo(data.folio)
            .then((enlistment) => {
                this.data = enlistment.result[0];
                var docDefinition = {
                    pageMargins: [40, 90, 40, 60],
                    header: {
                        columns: [
                            this.account && this.account.iso_img
                                ? {
                                      image: `data:image/jpeg;base64,${this.account.logo}`,
                                      width: 120,
                                      height: 60,
                                      alignment: 'left',
                                      opacity: 0.9,
                                      margin: [50, 10]
                                  }
                                : {},
                            this.account && this.account.iso_img
                                ? {
                                      image: `data:image/jpeg;base64,${this.account.iso_img}`,
                                      width: 200,
                                      height: 60,
                                      alignment: 'right',
                                      opacity: 0.9,
                                      margin: [0, 10]
                                  }
                                : {
                                      image: this.motion_logo,
                                      width: 200,
                                      height: 60,
                                      alignment: 'right',
                                      opacity: 0.9,
                                      margin: [0, 10]
                                  }
                        ],
                        columnGap: 200
                    },
                    footer: {
                        columns: [
                            {
                                text: 'monitoringinnovation.com',
                                link: 'http://monitoringinnovation.com',
                                alignment: 'right',
                                margin: [0, 10, 10, 0]
                            }
                        ]
                    },
                    content: [
                        {
                            text: `Alistamiento: ${this.data.folio}`,
                            fontSize: 16,
                            margin: [0, 5]
                        },
                        {
                            text: `Fecha: ${this.data.fecha}`,
                            fontSize: 16,
                            margin: [0, 5]
                        },
                        {
                            columns: [
                                [
                                    {
                                        text: `Vehiculo:`,
                                        fontSize: 12,
                                        alignment: 'center'
                                    },
                                    {
                                        text: `${this.data.vehiculo}`,
                                        fontSize: 14,
                                        alignment: 'center',
                                        bold: true
                                    }
                                ],
                                [
                                    {
                                        text: `Conductor:`,
                                        fontSize: 12,
                                        alignment: 'center'
                                    },
                                    {
                                        text: `${this.data.conductor}`,
                                        fontSize: 14,
                                        alignment: 'center',
                                        bold: true
                                    }
                                ],
                                [
                                    {
                                        text: `Revision Gerencia:`,
                                        fontSize: 12,
                                        alignment: 'center'
                                    },
                                    {
                                        text: `Sí`,
                                        fontSize: 14,
                                        alignment: 'center',
                                        bold: true
                                    }
                                ],
                                [
                                    {
                                        text: `Revision jefe de mantenimiento:`,
                                        fontSize: 12,
                                        alignment: 'center'
                                    },
                                    {
                                        text: `Sí`,
                                        fontSize: 14,
                                        alignment: 'center',
                                        bold: true
                                    }
                                ]
                            ],
                            margin: [0, 10]
                        },
                        {
                            layout: 'lightHorizontalLines',
                            table: {
                                // headers are automatically repeated if the table spans over multiple pages
                                // you can declare how many rows should be treated as headers
                                headerRows: 1,
                                widths: ['*', 100, 100],

                                body: [
                                    [
                                        {text: 'ITEM', bold: true},
                                        {text: 'CON NOVEDAD', bold: true},
                                        {text: 'SIN NOVEDAD', bold: true}
                                    ],
                                    [
                                        'Documentos del vehiculo',
                                        !this.data.documentos_vehiculo
                                            ? 'X'
                                            : '-',
                                        this.data.documentos_vehiculo
                                            ? 'X'
                                            : '-'
                                    ],
                                    [
                                        'Documentos del conductor',
                                        !this.data.documentos_conductor
                                            ? 'X'
                                            : '-',
                                        this.data.documentos_conductor
                                            ? 'X'
                                            : '-'
                                    ],
                                    [
                                        'Calcomania como conduzco',
                                        !this.data.calcomania ? 'X' : '-',
                                        this.data.calcomania ? 'X' : '-'
                                    ],
                                    [
                                        'Aire',
                                        !this.data.aire ? 'X' : '-',
                                        this.data.aire ? 'X' : '-'
                                    ],
                                    [
                                        'Aseo',
                                        !this.data.aseo ? 'X' : '-',
                                        this.data.aseo ? 'X' : '-'
                                    ],
                                    [
                                        'Bateria',
                                        !this.data.baterias ? 'X' : '-',
                                        this.data.baterias ? 'X' : '-'
                                    ],
                                    [
                                        'Botiquin',
                                        !this.data.botiquin ? 'X' : '-',
                                        this.data.botiquin ? 'X' : '-'
                                    ],
                                    [
                                        'Celular con minutos',
                                        !this.data.celular ? 'X' : '-',
                                        this.data.celular ? 'X' : '-'
                                    ],
                                    [
                                        'Cinturones',
                                        !this.data.cinturones ? 'X' : '-',
                                        this.data.cinturones ? 'X' : '-'
                                    ],
                                    [
                                        'Dispositivo de velocidad',
                                        !this.data.disp_velocidad ? 'X' : '-',
                                        this.data.disp_velocidad ? 'X' : '-'
                                    ],
                                    [
                                        'Equipo de carretera',
                                        !this.data.equipo_carretera ? 'X' : '-',
                                        this.data.equipo_carretera ? 'X' : '-'
                                    ],
                                    [
                                        'Estado escalera puerta conductor',
                                        !this.data.estado_esc_p_conductor
                                            ? 'X'
                                            : '-',
                                        this.data.estado_esc_p_conductor
                                            ? 'X'
                                            : '-'
                                    ],
                                    [
                                        'Estado escalera puerta pasajero',
                                        !this.data.estado_esc_p_pasajero
                                            ? 'X'
                                            : '-',
                                        this.data.estado_esc_p_pasajero
                                            ? 'X'
                                            : '-'
                                    ],
                                    [
                                        'Extintor',
                                        !this.data.extintor ? 'X' : '-',
                                        this.data.extintor ? 'X' : '-'
                                    ],
                                    [
                                        'Filtros',
                                        !this.data.filtros ? 'X' : '-',
                                        this.data.filtros ? 'X' : '-'
                                    ],
                                    [
                                        'Frenos',
                                        !this.data.frenos ? 'X' : '-',
                                        this.data.frenos ? 'X' : '-'
                                    ],
                                    [
                                        'Frenos de emergencia',
                                        !this.data.frenos_emergencia
                                            ? 'X'
                                            : '-',
                                        this.data.frenos_emergencia ? 'X' : '-'
                                    ],
                                    [
                                        'Herramientas',
                                        !this.data.herramientas ? 'X' : '-',
                                        this.data.herramientas ? 'X' : '-'
                                    ],
                                    [
                                        'Linterna',
                                        !this.data.linterna ? 'X' : '-',
                                        this.data.linterna ? 'X' : '-'
                                    ],
                                    [
                                        'Llantas',
                                        !this.data.llantas ? 'X' : '-',
                                        this.data.llantas ? 'X' : '-'
                                    ],
                                    [
                                        'Luces',
                                        !this.data.luces ? 'X' : '-',
                                        this.data.luces ? 'X' : '-'
                                    ],
                                    [
                                        'Motor',
                                        !this.data.motor ? 'X' : '-',
                                        this.data.motor ? 'X' : '-'
                                    ],
                                    [
                                        'Niveles',
                                        !this.data.niveles ? 'X' : '-',
                                        this.data.niveles ? 'X' : '-'
                                    ],
                                    [
                                        'Parabrisas',
                                        !this.data.parabrisas ? 'X' : '-',
                                        this.data.parabrisas ? 'X' : '-'
                                    ],
                                    [
                                        'Pito',
                                        !this.data.pito ? 'X' : '-',
                                        this.data.pito ? 'X' : '-'
                                    ],
                                    [
                                        'Repuesto',
                                        !this.data.repuesto ? 'X' : '-',
                                        this.data.repuesto ? 'X' : '-'
                                    ],
                                    [
                                        'Espejos retrovisores',
                                        !this.data.retrovisores ? 'X' : '-',
                                        this.data.retrovisores ? 'X' : '-'
                                    ],
                                    [
                                        'Ruteros',
                                        !this.data.ruteros ? 'X' : '-',
                                        this.data.ruteros ? 'X' : '-'
                                    ],
                                    [
                                        'Silla conductor',
                                        !this.data.silla_conductor ? 'X' : '-',
                                        this.data.silla_conductor ? 'X' : '-'
                                    ],
                                    [
                                        'Silleteria general',
                                        !this.data.silleteria ? 'X' : '-',
                                        this.data.silleteria ? 'X' : '-'
                                    ],
                                    [
                                        'Tapas',
                                        !this.data.tapas ? 'X' : '-',
                                        this.data.tapas ? 'X' : '-'
                                    ],
                                    [
                                        'Tension de correas',
                                        !this.data.tension ? 'X' : '-',
                                        this.data.tension ? 'X' : '-'
                                    ],
                                    [
                                        'Transmision',
                                        !this.data.transmision ? 'X' : '-',
                                        this.data.transmision ? 'X' : '-'
                                    ]
                                ]
                            }
                        },
                        {
                            text: `Novedades`,
                            fontSize: 16,
                            bold: true,
                            margin: [0, 5]
                        },
                        !this.data.documentos_vehiculo
                            ? [
                                  {
                                      text: `Documentos del vehiculo`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_documentos_vehiculo}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: ` Descripcion: ${this.data.desc_documentos_vehiculo}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.documentos_conductor
                            ? [
                                  {
                                      text: `Documentos del conductor`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_documentos_conductor}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: ` Descripcion: ${this.data.desc_documentos_conductor}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.calcomania
                            ? [
                                  {
                                      text: `Calcomania como conduzco`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_calcomania}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: ` Descripcion: ${this.data.desc_calcomania}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.aire
                            ? [
                                  {
                                      text: `Aire`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_aire}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: ` Descripcion: ${this.data.desc_aire}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.aseo
                            ? [
                                  {
                                      text: `Aseo`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_aseo}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: ` Descripcion: ${this.data.desc_aseo}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.baterias
                            ? [
                                  {
                                      text: `Bateria`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_baterias}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: ` Descripcion: ${this.data.desc_baterias}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.botiquin
                            ? [
                                  {
                                      text: `Botiquin`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_botiquin}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_botiquin}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.celular
                            ? [
                                  {
                                      text: `Celular con minutos`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_celular}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_celular}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.cinturones
                            ? [
                                  {
                                      text: `Cinturones`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_cinturones}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_cinturones}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.disp_velocidad
                            ? [
                                  {
                                      text: `Dispositivo de velocidad`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_disp_velocidad}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_disp_velocidad}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.equipo_carretera
                            ? [
                                  {
                                      text: `Equipo de carretera`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_equipo_carretera}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_equipo_carretera}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.estado_esc_p_conductor
                            ? [
                                  {
                                      text: `Estado escalera puerta conductor`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_estado_esc_p_conductor}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_estado_esc_p_conductor}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.estado_esc_p_pasajero
                            ? [
                                  {
                                      text: `Estado escalera puerta pasajero`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_estado_esc_p_pasajero}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_estado_esc_p_pasajero}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.extintor
                            ? [
                                  {
                                      text: `Extintor`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_extintor}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_extintor}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.filtros
                            ? [
                                  {
                                      text: `Filtros`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_filtros}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_filtros}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.frenos
                            ? [
                                  {
                                      text: `Frenos`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_frenos}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_frenos}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.frenos_emergencia
                            ? [
                                  {
                                      text: `Frenos de emergencia`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_frenos_emergencia}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_frenos_emergencia}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.herramientas
                            ? [
                                  {
                                      text: `Herramientas`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_herramientas}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_herramientas}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.linterna
                            ? [
                                  {
                                      text: `Linterna`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_linterna}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_linterna}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.llantas
                            ? [
                                  {
                                      text: `Llantas`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_llantas}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_llantas}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.luces
                            ? [
                                  {
                                      text: `Luces`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_luces}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_luces}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.motor
                            ? [
                                  {
                                      text: `Motor`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_motor}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_motor}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.niveles
                            ? [
                                  {
                                      text: `Niveles`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_niveles}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_niveles}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.parabrisas
                            ? [
                                  {
                                      text: `Parabrisas`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_parabrisas}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_parabrisas}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.pito
                            ? [
                                  {
                                      text: `Pito`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_pito}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_pito}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.repuesto
                            ? [
                                  {
                                      text: `Repuesto`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_repuesto}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_repuesto}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.retrovisores
                            ? [
                                  {
                                      text: `Espejos retrovisores`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_retrovisores}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: `Descripcion: ${this.data.desc_retrovisores}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.ruteros
                            ? [
                                  {
                                      text: `Ruteros`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_ruteros}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: ` Descripcion: ${this.data.desc_ruteros}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.silla_conductor
                            ? [
                                  {
                                      text: `Silla conductor`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_silla_conductor}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: ` Descripcion: ${this.data.desc_silla_conductor}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.silleteria
                            ? [
                                  {
                                      text: `Silleteria general`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_silleteria}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: ` Descripcion: ${this.data.desc_silleteria}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.tapas
                            ? [
                                  {
                                      text: `Tapas`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_tapas}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: ` Descripcion: ${this.data.desc_tapas}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.tension
                            ? [
                                  {
                                      text: `Tension de correas`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_tension}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: ` Descripcion: ${this.data.desc_tension}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : [],
                        !this.data.transmision
                            ? [
                                  {
                                      text: `Transmision`,
                                      fontSize: 15,
                                      alignment: 'center',
                                      margin: [0, 5],
                                      bold: true
                                  },
                                  {
                                      image: `data:image/jpeg;base64,${this.data.img_tension}`,
                                      width: 250,
                                      margin: [0, 10],
                                      alignment: 'center'
                                  },
                                  {
                                      text: ` Descripcion: ${this.data.desc_transmision}`,
                                      fontSize: 12,
                                      alignment: 'center'
                                  }
                              ]
                            : []
                    ]
                };

                pdfMake.tableLayouts = {
                    exampleLayout: {
                        hLineWidth: function (i, node) {
                            if (i === 0 || i === node.table.body.length) {
                                return 0;
                            }
                            return i === node.table.headerRows ? 2 : 1;
                        },
                        vLineWidth: function (i) {
                            return 0;
                        },
                        hLineColor: function (i) {
                            return i === 1 ? 'black' : '#8a8a8a';
                        },
                        paddingLeft: function (i) {
                            return i === 0 ? 0 : 8;
                        },
                        paddingRight: function (i, node) {
                            return i === node.table.widths.length - 1 ? 0 : 8;
                        }
                    }
                };
                pdfMake.createPdf(docDefinition).open();
                this.loading = false;
            });
    }

    getOldEnlistmentByItem(key, value) {
        if (key === 'conductor' && value) {
            this.apiService
                .getOldEnlistmentsInfo(
                    this.old_currentPage,
                    this.old_pageSize,
                    '',
                    '',
                    '',
                    key,
                    value
                )
                .then((enlistments) => {
                    this.old_enlistments = enlistments.result;
                    this.old_enlistments_count = enlistments.total_count;
                    this.old_enlistmentModel.records = this.old_enlistments;
                    this.old_enlistmentModel.pagination = {
                        currentPage: this.old_currentPage,
                        pageSize: this.old_pageSize,
                        pageCount: enlistments.count,
                        rowCount: this.old_enlistments_count
                    };
                });
        } else if (key === 'vehiculo' && value) {
            this.apiService
                .getOldEnlistmentsInfo(
                    this.old_currentPage,
                    this.old_pageSize,
                    '',
                    '',
                    '',
                    key,
                    value
                )
                .then((enlistments) => {
                    this.old_enlistments = enlistments.result;
                    this.old_enlistments_count = enlistments.total_count;
                    this.old_enlistmentModel.records = this.old_enlistments;
                    this.old_enlistmentModel.pagination = {
                        currentPage: this.old_currentPage,
                        pageSize: this.old_pageSize,
                        pageCount: enlistments.count,
                        rowCount: this.old_enlistments_count
                    };
                    this.cd.detectChanges();
                });
        } else {
            this.getOldEnlistments(this.old_currentPage, this.old_searchby);
        }
    }

    onRemove(index: number) {
        console.log('remove event ! ');
    }

    old_paginatorEvent(currentPage: number) {
        this.old_currentPage = currentPage;
        this.getOldEnlistments(currentPage, this.old_searchby);
    }

    old_pageSizeEvent(pageSize: number) {
        this.old_pageSize = pageSize;
        this.old_paginatorEvent(this.old_currentPage);
    }

    old_searchP(searchby: string) {
        this.old_searchby = searchby;
        this.getOldEnlistments(
            this.old_currentPage,
            searchby ? searchby : this.old_searchby
        );
    }

    showSingleEnlistment(data) {
        this.modalService.$modal.emit(true);
        this.selected_enlistment = data;
    }

    updateFilter(event) {
        this.getOldEnlistmentSorted(event.key, event.order);
    }

    filterUnit(event) {
        this.getOldEnlistmentByItem(event.key, event.value);
    }

    filterDriver(event) {
        this.getOldEnlistmentByItem(event.key, event.value);
    }

    getUnitValues(): Value[] {
        let unitValues: Value[] = [];
        this.apiService.getAllOldUnits().then((units) => {
            this.old_vehicles_count = units.length;
            for (let unit of units) {
                let unitValue = new Value(unit.name, unit.name);
                unitValues.push(unitValue);
            }
        });
        return unitValues;
    }

    getDriverValues(): Value[] {
        let driverValues: Value[] = [];
        this.apiService.getAllOldDrivers().then((drivers) => {
            for (let driver of drivers) {
                let driverValue = new Value(driver.name, driver.name);
                driverValues.push(driverValue);
            }
        });
        return driverValues;
    }

    showSingleCovidForm(folio) {
        this.apiService.getOldSingleCovidInfo(folio).then((covid) => {
            this.selected_form = covid;
            this.modalService.$card_selected.emit(true);
        });
    }

    validateRevision(event) {
    }
}
